export const formatDate = (dateString) => {
	const date = new Date(dateString);
	return date.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
}

export const isSingleBlog = (route) => {
	return route.name === 'post';
}

export const isArchiveBlog = (route) => {
	return route.name === 'blog';
}

export const stripHTML = (html) => {
	const doc = new DOMParser().parseFromString(html, 'text/html');
	return doc.body.textContent || "";
}
